import React from 'react';
import { Button } from 'react-bootstrap';
import StickyLabel from 'components/Flux/Shared/StickyLabel';
import useRevisionData from 'utils/hooks/flux/automatic/useRevisionData';
import { cssVar } from 'constants/theme';
import './index.scss';

export interface RowData {
  label: string,
  values: {
    value: string,
    colorName: string,
  }[]
}

export function translateClosestDates(dateCode: string) {
  switch (dateCode) {
    case 'd-00':
      return 'hoje';
    case 'd-01':
      return 'ontem';
    default:
      return dateCode;
  }
}

const DESTAQUE_REVISAO = '#FF00007F'; // tema: cor de dado

export default function RevisionTable({ popDataModal, stickyRowLabel = false }: {
  popDataModal: (chosenModel: string, chosenPeriod: string) => void,
  /** Congela a coluna de rótulo com teto de largura. Só o mobile passa — desktop segue igual. */
  stickyRowLabel?: boolean
}) {
  const { expectedDataResponse, revisionRows, revisionData } = useRevisionData();
  const colLabels = revisionData?.colLabels ?? [];

  const cellStyle = (backgroundColor: string = cssVar('bg-surface')): React.CSSProperties => ({
    textDecoration: 'none',
    // Destaque vermelho é cor de dado e leva texto branco; o resto segue o tema.
    color: backgroundColor === DESTAQUE_REVISAO ? 'white' : cssVar('text-strong'),
    backgroundColor,
  });

  const tableClass = [
    'table',
    'sticky-table-col-row',
    stickyRowLabel ? 'sticky-table-capped' : '',
    'revision-table',
  ].filter(Boolean).join(' ');

  return (
    <div>
      <table className={tableClass}>
        <thead>
          <tr>
            <th>
              {stickyRowLabel
                ? <StickyLabel text="Simulações automáticas" />
                : 'Simulações automáticas'}
            </th>
            {expectedDataResponse.colLabels.map((colLabel) => (
              <th scope="col" className="revision-col-label" key={`${colLabel}`}>
                {translateClosestDates(colLabel)}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {revisionRows.map((rowData) => (
            <tr key={rowData.label}>
              <th scope="row" className="revision-row-label">
                {stickyRowLabel
                  ? <StickyLabel text={rowData.label} />
                  : rowData.label}
              </th>
              {rowData.values.map(({ value, colorName }, index) => (
                <td
                  className="revision-value-cell"
                  key={`${rowData.label}-${colLabels[index]}-${value}`}
                >
                  <Button variant="link" style={cellStyle(colorName)} onClick={() => popDataModal(rowData.label, colLabels[index])}>
                    {value || ''}
                  </Button>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
